import timer_gen_2 from '@devices/settings/device_settings/timer_gen_2.js';
import roller_app_setting_gen_2 from '@devices/settings/device_settings/roller_app_setting_gen_2.js';

export default {
	name: 'ShellyPlusDimmer',
	friendly_name: 'Plus Dimmer TEST',
	family: 'light',
	isPM: true,
	modes: {
		white: {
			availableViews: ['basic', 'advanced'],
			channels: 1,
			notifications: [
				'offline',
				'device_problem',
				'forgotten_lights',
				'overvoltage',
				'overtemperature',
			],
			color: false,
			color_temp: false,
			effects: false,
			slider: 'brightness',
			brightness: 1,
			settings: [
				timer_gen_2,
				roller_app_setting_gen_2,
				{
					title: 'settings',
					components: [
						{ title: 'eco_mode', component: 'eco_mode_g2' },
						{ title: 'device_name', component: 'device_name_g2' },
						{ title: 'firmware_version', component: 'firmware_update' },
						{ title: 'geo_location_and_time_zone', component: 'location_g2' },
						{ title: 'device_reboot', component: 'device_reboot' },
						{ title: 'factory_reset', component: 'factory_reset' },
						{ title: 'device_information', component: 'device_information' },
					],
				},
			],
		},
	},
};
